import { useCallback, useState } from 'react';
import { EBadReviewReason } from '../types/constants';
const useBadReviewReasonSelection = () => {
    const [selectedReason, setSelectedReason] = useState('');
    const [otherComment, setOtherComment] = useState('');
    const isOtherSelected = selectedReason === EBadReviewReason.Other;
    const handleReasonChange = useCallback((reasonId) => {
        setSelectedReason(reasonId);
        if (reasonId !== EBadReviewReason.Other)
            setOtherComment('');
    }, []);
    return [selectedReason, otherComment, setOtherComment, isOtherSelected, handleReasonChange];
};
export default useBadReviewReasonSelection;
